import React, { Component } from 'react'
import styles from './ImageSlider.module.scss'
import Slider from 'react-slick'
import Image from 'components/Image'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

class ImageSlider extends Component {
	state = { loading: true }

	componentDidMount() {
		this.loadImages()
	}

	shouldComponentUpdate(prevProps, { loading }) {
		return loading !== this.state.loading || this.imgChangeCkeck(prevProps)
	}

	componentDidUpdate(prevProps) {
		if(this.imgChangeCkeck(prevProps)) {
			this.setState({ loading: true }, this.loadImages) // eslint-disable-line react/no-did-update-set-state
		}
	}

	imgChangeCkeck = (prevProps) =>
		prevProps.imgArr.length !== this.props.imgArr.length ||
		prevProps.imgArr.some(({ key }, i) => key !== this.props.imgArr[i].key)

	loadImages = () => {
		const images = this.props.imgArr.map(async ({ key, ...rest }) => {
			// const url = await loadImgByKey(key);
			// (new Image()).src = url
			return { key, ...rest }
		})
		return Promise.all(images).then(res => {
			this.setState({
				loading: false,
				images: res
			})
		})
	}

	render({ current, images } = this.state, { noDataText } = this.props) {
		if(this.state.loading) {
			return null
		}

		const settings = {
			dots: true,
			arrows: false,
			infinite: true,
			adaptiveHeight: true,
			autoplay: true,
			draggable: false,
			pauseOnHover: false,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1
		}

		const sizeStyle = {
			width: 1280,
			height: 800
		}

		return (
			<div className={styles.root}>
				<div style={sizeStyle}>
					<Slider className={styles.slider} {...settings}>
						{
							images.length ? images.map(({ name, key }, i) => (
								<div key={i} className={styles.slide} style={sizeStyle}><Image imgKey={key} alt={name}/></div>
							)) :
								<div className={styles.slide}>{noDataText}</div>
						}
					</Slider>
				</div>
			</div>
		)
	}
}

export default ImageSlider
